import classNames from "classnames";
import { useState } from "react";
import { NavLink } from "react-router-dom";

import styles from "./MenuItem.module.scss";

import Icons from "@/components/icons";
import { MenuItemProps } from "@/types/menu/MenuItemProps";

const MenuItem: React.FC<MenuItemProps> = ({ active, disabled, icon, label, onClick, path, submenuItems }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    if (submenuItems) {
      setIsOpen(!isOpen);
    } else if (onClick && !disabled) {
      onClick();
    }
  };

  const content = (
    <>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "8px"
      }}>
        {icon}
        <span className={styles.label}>{label}</span>
      </div>
      {submenuItems && (
        <Icons.ArrowDropRightIcon fontSize={24} className={styles.arrow} />
      )}
    </>
  );

  const itemClassName = classNames(styles.sidebarSubItem, {
    [styles.active]: active,
  });

  if (path) {
    return (
      <NavLink to={path} className={itemClassName}>
        {content}
      </NavLink>
    );
  }

  return (
    <div className={styles.menuItemWrapper}>
      <div className={`${itemClassName} ${disabled && styles.disable}`} role="button" tabIndex={disabled ? -1 : 0} onClick={handleClick} onKeyDown={(e) => { if (!disabled && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); handleClick(); } }}>
        {content}
      </div>
      {submenuItems && isOpen && (
        <div className={styles.submenu}>
          {submenuItems.map((subItem, index) => (
            <MenuItem
              active={subItem.active}
              disabled={subItem.disabled}
              icon={subItem.icon}
              key={index}
              label={subItem.label}
              onClick={subItem.onClick}
              path={subItem.path} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MenuItem;